import type { JSX } from 'react';

import type { StarfishIconRef } from '@/app/common/icons/starfish';

export enum FeatureType {
  dates = 'dates',
  bold = 'bold',
  normal = 'normal',
  primary = 'primary',
  waiting = 'waiting',
  danger = 'danger',
  offer = 'offer',
  offerGray = 'offerGray',
  gray = 'gray',
  link = 'link',
}

export type Feature = {
  text?: string;
  featureType: FeatureType;
  /**
   * A named icon the row will draw. A plain string is a local multi-colour
   * asset (the lastminute deals and Pink People artwork, TSH), which a
   * single-colour design system glyph cannot reproduce.
   */
  icon?: StarfishIconRef | string;
  iconRight?: StarfishIconRef | string;
  tooltip?: JSX.Element | string;
  tooltipSize?: number;
  tooltipPosition?: 'center' | 'left' | 'right';
  className?: string;
  link?: <T extends unknown[]>(...args: T) => void;
  Modal?: ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => JSX.Element;
  callback?: () => void;
};

export const waitingItem: Feature = {
  text: '',
  className: 'loader',
  featureType: FeatureType.waiting,
};

export const waitingFlightItem: Feature = {
  text: '',
  className: 'loader flight',
  featureType: FeatureType.waiting,
};

export const waitingDateItem: Feature = {
  text: '',
  className: 'loader date',
  featureType: FeatureType.waiting,
};
